// extracted by mini-css-extract-plugin
export default {"modal-api-key-area":"api-access-modal_modal-api-key-area__ilpaU","modal-api-key-note-title":"api-access-modal_modal-api-key-note-title__hHhki"};